import { itemCategoryActionSelectors as selector } from "../Selectors/index";
import ItemCategoryService from "../../Service/Item-master/itemCategory.service";
import itemSubCategoryService from "../../Service/Item-master/itemSubCategory.service";
import { openSnackbar } from "./snackbarActions";


export const getItemCategory = () => {
  return {
    type: selector.GET_ITEM_CATEGORY,
  };
};

export const getSubCategory = () => {
  return {
    type: selector.GET_SUB_CATEGORY,
  };
};

export const getItemCategorySuccess = (itemCategory) => {
  return {
    type: selector.GET_ITEM_CATEGORY_SUCCESS,
    payload: itemCategory,
  };
};

export const getSubCategorySuccess = (subCategory) => {
  return {
    type: selector.GET_SUB_CATEGORY_SUCCESS,
    payload: subCategory,
  };
};

export const fetchItemCategory = (val) => {
  return async (dispatch) => {
    dispatch(getItemCategory());
    try {
      const res =
        val && val !== ""
          ? await ItemCategoryService.search(val)
          : await ItemCategoryService.getAll();
      dispatch(getItemCategorySuccess(res));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e.message));
    }
  };
};
export const fetchSubCategory = (val => {
    return async (dispatch) => {
        dispatch(getSubCategory());
        try {
          const res = await itemSubCategoryService.getAll();
          dispatch(getSubCategorySuccess(res));
        } catch (e) {
          dispatch(openSnackbar(true, "error", e.message));
        }
    };
  });

